import GradientBackground from '../GradientBackground/GradientBackground';
import styles from './Background.module.css'
import Footer from '../Footer/Footer';

function Background() {

  return (
    <div className={styles.Background}>
      <div className={styles.BlackBackground}>
        <Footer />
      </div>
      <div className={styles.BackgroundWrap}>
        <div className={styles.GradientBackground}>
          <GradientBackground />
        </div>
      </div>
    </div>
  );
}

export default Background;